import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Settings, LogOut, User, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProfileDropdownItem from "./ProfileDropdownItem";

const ProfileDropdown = ({ imgUrl, userName, handleLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const closeDropdown = () => setIsOpen(false);

  return (
    <div className="relative">
      {/* Tombol Utama (Hanya Foto & Panah) */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 p-1 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-white/10 hover:shadow-md transition-all"
      >
        <div className="h-10 w-10 rounded-full overflow-hidden border border-slate-100 dark:border-slate-800 bg-slate-100 flex items-center justify-center">
          {imgUrl ? (
            <img 
              src={imgUrl} 
              alt="Profile avatar" 
              className="h-full w-full object-cover"
            />
          ) : (
            <User size={20} className="text-slate-400" />
          )}
        </div>
        <div className="pr-2">
          <ChevronDown 
            size={14} 
            className={`text-slate-500 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} 
          />
        </div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={closeDropdown} />
            
            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.95 }}
              className="absolute right-0 mt-3 w-52 bg-white dark:bg-slate-950 rounded-[1.5rem] shadow-2xl border border-slate-100 dark:border-white/5 overflow-hidden z-20 p-2"
            >
              {/* --- BAGIAN USERNAME (DI ATAS SETTINGS) --- */}
              <div className="px-4 py-3 mb-1">
                <p className="text-sm font-bold text-slate-800 dark:text-white truncate">
                  {userName || "User"}
                </p>
              </div>

              <div className="h-[1px] bg-slate-100 dark:bg-white/5 mb-1" />

              {/* --- MENU ITEMS --- */}
              <ProfileDropdownItem 
                icon={LayoutDashboard} 
                label="Dashboard" 
                onClick={() => { navigate("/admin"); closeDropdown(); }} 
              />

              <div className="h-[1px] bg-slate-100 dark:bg-white/5 my-1" />

              <ProfileDropdownItem 
                icon={Settings} 
                label="Settings" 
                onClick={() => { navigate("/settings"); closeDropdown(); }} 
              />
              
              <div className="h-[1px] bg-slate-100 dark:bg-white/5 my-1" />
              
              <ProfileDropdownItem 
                icon={LogOut} 
                label="Logout" 
                variant="danger"
                onClick={() => { handleLogout(); closeDropdown(); }} 
              />
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ProfileDropdown;